;(function () {
  'use strict'

  // 配置
  const CONFIG = {
    // 只追踪这些标签
    trackTags: ['A', 'BUTTON', 'INPUT', 'IMG', 'SELECT', 'TEXTAREA'],
    // 文本长度限制
    maxTextLength: 100,
    // 采样率 (1 = 100%, 0.5 = 50%)
    sampleRate: 1,
  }

  function shouldTrack(element) {
    // 检查标签
    if (!CONFIG.trackTags.includes(element.tagName)) return false

    // 检查是否可见
    const rect = element.getBoundingClientRect()
    if (rect.width === 0 || rect.height === 0) return false

    return true
  }

  function getElementData(element, event) {
    return {
      event_label:
        element.textContent?.trim().substring(0, CONFIG.maxTextLength) ||
        element.alt ||
        element.value ||
        'unnamed_element',
      element_tag: element.tagName.toLowerCase(),
      element_class: (element.className || '').toString().substring(0, 100),
      element_id: element.id || '',
      element_href: element.href || element.closest('a')?.href || '',
      page_path: window.location.pathname,
      click_timestamp: new Date().toISOString(),
      dataset: element.dataset || {},
    }
  }

  function buttonGtagFunction(eventData) {
    if (typeof gtag === 'function') {
      switch (eventData.dataset.buttonText || eventData.event_label) {
        case 'Buy Now':
          gtag('event', 'index_BuyNow_click', eventData)
          break
        case 'Buy Founder Edition Now':
          gtag('event', 'product_BuyFounderEditionNow_click', eventData)
          break
        case 'Buy Best Deal Now':
          gtag('event', 'product_BuyBestDealNow_click', eventData)
          break
        default:
          break
      }
    }
  }

  document.addEventListener('click', function (e) {
    // 采样
    if (Math.random() > CONFIG.sampleRate) return

    const element = e.target
    if (!shouldTrack(element)) return
    if (typeof gtag === 'function') {
      const eventData = getElementData(element, e)
      if (eventData.element_tag !== 'BUTTON') {
        buttonGtagFunction(eventData)
      } else {
        gtag('event', 'element_click', getElementData(element, e))
      }
      //   gtag('event', 'element_click', getElementData(element, e));
    }
  })
})()
